"use client";

export { Loader } from "./loader/index.js"